var map = {
	"./AMD-logo.png": 92,
	"./Amazon_Web_Services-Logo.wine.svg": 93,
	"./BritishCouncil_Logo.png": 94,
	"./Logo-HCMIU.svg": 95,
	"./SCC_logo_NEW.png": 96,
	"./address_image.svg": 97,
	"./animated_ashutosh.png": 98,
	"./animated_logo.svg": 99,
	"./aws_logo.png": 100,
	"./blogs_image.svg": 101,
	"./cloud_infrastructure.svg": 102,
	"./codeInLogo.png": 103,
	"./contactMail.png": 104,
	"./coursera_logo.png": 105,
	"./data_science.svg": 106,
	"./deeplearning_ai_logo.png": 107,
	"./delhivery_logo.png": 108,
	"./developerActivity.svg": 109,
	"./dsc_logo.png": 110,
	"./education.svg": 111,
	"./experience.svg": 112,
	"./feelingProud.svg": 113,
	"./freecopy_logo.png": 114,
	"./fullstack.svg": 115,
	"./gcp_logo.png": 116,
	"./github_logo.png": 117,
	"./googleAssistant.jpg": 118,
	"./googleAssistant.svg": 119,
	"./google_logo.png": 120,
	"./ibm_logo.png": 121,
	"./iiitk_logo.png": 122,
	"./intel_logo.jpg": 123,
	"./jsFramework.svg": 124,
	"./legato_logo.png": 125,
	"./manOnTable.svg": 126,
	"./microsoft_logo.png": 127,
	"./mozilla_logo.png": 128,
	"./muffito_logo.png": 129,
	"./nextuLogo.jpg": 130,
	"./nptel_logo.png": 131,
	"./portfolio.gif": 132,
	"./programmer.svg": 133,
	"./projects_image.svg": 134,
	"./pwa.png": 135,
	"./qtscicon.png": 136,
	"./saayaHealthLogo.png": 137,
	"./stanford_logo.png": 138,
	"./talksCardBack.svg": 139,
	"./talksCardBackAlt.svg": 140,
	"./tiktok_logo.png": 141,
	"./ui_ux_design.svg": 142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;